import React from 'react';
import { Provider } from 'react-redux';
import {
    BrowserRouter as Router,
} from 'react-router-dom';

import './assets/css/bootstrap.min.css';
import './assets/css/app.css';
import './assets/css/all.css';

import store from './store';
import ScrollToTop from './components/scroll-to-top';
import { Routes } from './router/Routes';
import { RestaurantProvider } from './contexts/restaurant.context';
import { SettingsProvider } from './contexts/settings.context';
import { CartProvider } from './contexts/cart.context';
import { AuthProvider } from './contexts/auth.context';
import { CategoryGroupProvider } from './contexts/category-group.context';

function App() {
    return (
        <RestaurantProvider>
            <Provider store={store}>
                <SettingsProvider>
                    <AuthProvider>
                        <CartProvider>
                            <CategoryGroupProvider>
                                <Router>
                                    <ScrollToTop />
                                    <Routes />
                                </Router>
                            </CategoryGroupProvider>
                        </CartProvider>
                    </AuthProvider>
                </SettingsProvider>
            </Provider>
        </RestaurantProvider>
    );
}

export default App;
